// src/admin/components/AgentReport.js
import React, { useEffect, useState } from "react";
import config from "../../config";
import { toast } from 'react-toastify';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
  const company = JSON.parse(sessionStorage.getItem("companyDetails"));
export default function AgentReport() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = sessionStorage.getItem("token");

  /* ================= FETCH AGENTS ================= */
  useEffect(() => {
    fetch(`${config.API_BASE_URL}/Home/GetallAgent/${encodeURIComponent(company?.id)}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("GetallAgent API response:", data); // 👈 DEBUG
        setAgents(data || []);
      })
      .catch((err) => {
        console.error("GetallAgent API error:", err);
        toast.error("Failed to load agents");
      })
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4 }}>
      <Typography
        variant="h4"
        fontWeight="bold"
        mb={4}
        textAlign="center"
      >
        🧑‍💼 Agent Report
      </Typography>

      <Paper elevation={3}>
        <TableContainer sx={{ maxHeight: "75vh" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {[
                  "#",
                  "Agent Name",
                  "Mobile",
                  "Address",
                  "Commission",
                  "Created Date",
                ].map((h) => (
                  <TableCell key={h} sx={{ fontWeight: "bold" }}>
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {agents.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No agents found
                  </TableCell>
                </TableRow>
              ) : (
                agents.map((a, i) => (
                  <TableRow key={a.id || i}>
                    <TableCell>{i + 1}</TableCell>
                    <TableCell>{a.name || "-"}</TableCell>
                    <TableCell>{a.mobile || "-"}</TableCell>
                    <TableCell>{a.address || "-"}</TableCell>
                    <TableCell>{a.commission || "-"}%</TableCell>
                    <TableCell>
                      {a.create
                        ? new Date(a.create).toLocaleDateString('en-GB')
                        : "-"}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
